export default "/dist/files/icone_banques.69bf2241aaf661fb16452fcdda820f6b.svg";